import { ref, onMounted } from 'vue';
import store from '@/store';
import { config } from '@/config';
import { useToast } from '@/composables/common/useToast';

/**
 * Composable para la vista Liberar Asiento (back.abonados.liberar.asiento).
 *
 * @param {{ lista_id: number|string, abonado_id: number|string }} props - route params
 */
export function useLiberarAsiento(props) {
    const toast = useToast();

    const loading = ref(true);
    const eventos = ref(null);

    /** Evento y sesion seleccionados para pasar al modal */
    const eventoSelected = ref(null);
    const sesionSelected = ref(null);

    /**
     * Carga la lista de eventos del abonado.
     */
    async function fetchEventos() {
        loading.value = true;

        try {
            const params = {
                filters: {},
                abonado_id: props.abonado_id,
            };

            const res = await store.dispatch(
                config.getVuexAlias('back.abonados.eventos'),
                params,
            );

            eventos.value = res.data.data;
        } catch (err) {
            console.error('Error fetching eventos:', err);
            toast.error('Error al cargar los eventos');
        } finally {
            loading.value = false;
        }
    }

    /**
     * Prepara los datos para abrir el modal de confirmación.
     * Retorna true si hay evento y sesion seleccionados.
     */
    function selectForLiberar(evt, ses) {
        if (!evt || !ses) {
            toast.error('Debes seleccionar una sesión');
            return false;
        }
        eventoSelected.value = evt;
        sesionSelected.value = ses;
        return true;
    }

    /**
     * Callback cuando se cierra el modal.
     * Refresca los eventos si se liberó el asiento.
     */
    function onModalClose(modalName, actualizar) {
        eventoSelected.value = null;
        sesionSelected.value = null;

        if (actualizar) {
            fetchEventos();
        }
    }

    onMounted(() => {
        fetchEventos();
    });

    return {
        eventos,
        loading,
        eventoSelected,
        sesionSelected,
        fetchEventos,
        selectForLiberar,
        onModalClose,
    };
}
